import { useAilaStore } from "@features/session/hooks/useAilaStore";
import { isWeb } from "@helpers/platform";
import { useAppTheme } from "@hooks/useAppTheme";
import type { UnifiedCitation } from "@memorang/types/src/session/new-session";
import Box from "@memorang/ui/src/components/Box";
import { References } from "@memorang/ui/src/components/ChatUI/References";
import CustomListSubheaderContainer from "components/CustomListSubheaderContainer";
import { useRouter } from "expo-router";
import { useState } from "react";
import { Linking } from "react-native";
import CitationSourceDialog from "./CitationSourceDialog";

type Props = {
	citations: UnifiedCitation[];
	useWebColors?: boolean;
	useBottomSheetFlatList?: boolean;
};

export const Citations = ({
	citations,
	useWebColors = isWeb,
	useBottomSheetFlatList,
}: Props) => {
	const router = useRouter();
	const updateShowDrawer = useAilaStore((state) => state.updateShowDrawer);
	const [citationsPageNumber, setCitationsPageNumber] = useState<number | null>(
		null,
	);
	const theme = useAppTheme();
	const buttonContainerColor = useWebColors
		? theme.colors.primary
		: theme.colors.surfaceDisabled;
	const buttonIconColor = useWebColors
		? theme.colors.onPrimary
		: theme.colors.onSurfaceDisabled;
	const backgroundColor = useWebColors
		? theme.colors.primaryContainer
		: theme.colors.surface;

	const openUrl = (url: string) => {
		if (isWeb) {
			window.open(url, "_blank");
		} else {
			Linking.openURL(url);
		}
	};

	const handleOnPressReference = (reference: UnifiedCitation) => {
		if (reference.url) {
			openUrl(reference.url);
			return;
		}
		if (reference.page) {
			if (isWeb) {
				setCitationsPageNumber(reference.page);
				return;
			}
			updateShowDrawer(true);
			router.push(`/citation/${reference.page}`);
		}
	};

	return (
		<Box gap={8}>
			<CustomListSubheaderContainer enableGutters={false}>
				Citations
			</CustomListSubheaderContainer>
			<References
				withAccordion={false}
				onPressReference={handleOnPressReference}
				references={citations}
				referenceStyle={{
					backgroundColor,
				}}
				buttonContainerColor={buttonContainerColor}
				buttonIconColor={buttonIconColor}
				useBottomSheetFlatList={useBottomSheetFlatList}
			/>
			<CitationSourceDialog
				pageNumber={citationsPageNumber}
				visible={citationsPageNumber !== null}
				handleClose={() => setCitationsPageNumber(null)}
			/>
		</Box>
	);
};
